import { render } from "./DownloadAppEditor.vue?vue&type=template&id=5b3987de&scoped=true"
import script from "./DownloadAppEditor.vue?vue&type=script&lang=js"
export * from "./DownloadAppEditor.vue?vue&type=script&lang=js"

import "./DownloadAppEditor.vue?vue&type=style&index=0&id=5b3987de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3987de"]])

export default __exports__